/* How-to-use walkthroughs for Diffuser Help, keyed by model (see ap-diffuser-help.js M map).
 * Generated from docs/research/diffuser-help/how-to-use.json by scripts/build_dh_howto.mjs; do not hand-edit. */
window.APDH_HOWTO = {
 "tower-pro": {
  "steps": [
   {
    "title": "Check the box",
    "body": [
     "Your box has the diffuser, an empty 120 ml bottle and a remote.",
     "It also has a USB-C cable, an adapter, a metal hook, a spare nozzle and a rubber seal ring."
    ]
   },
   {
    "title": "Fill the bottle",
    "body": [
     "Lift the top part straight out. The bottle comes up with it.",
     "Unscrew the bottle and fill it with waterless fragrance oil. Never add water.",
     "Screw it back on until snug, with the straw down in the oil.",
     "Lower the top part back in until it sits flush. There's no click."
    ]
   },
   {
    "title": "Plug it in and turn it on",
    "body": [
     "Stand it upright on a flat, steady surface. Don't tilt it with oil inside.",
     "Plug in the USB-C cable and adapter from the box. Don't use any other charger.",
     "Hold the power button on the front for 2 seconds, or press ON/OFF on the remote."
    ]
   },
   {
    "title": "Choose the strength",
    "body": [
     "Out of the box it's on L2: 30 seconds on, 2 minutes off.",
     "Press L1 to L6 on the remote. No remote? Press the power button once to step up a level.",
     "L1 is the strongest: 30 seconds on, 60 seconds off.",
     "L6 is the lightest: 30 seconds on, 6 minutes off."
    ]
   },
   {
    "title": "Set the timer and light",
    "body": [
     "Out of the box it switches itself off after 4 hours.",
     "Double-press the power button to change it. One light is 1 hour, two 2 hours, three 4 hours, four 8 hours.",
     "Or press 1H, 4H or 8H on the remote.",
     "Press LIGHT on the remote for low, medium, high or off."
    ]
   },
   {
    "title": "Connect the Smart Life app",
    "body": [
     "Turn on Wi-Fi and Bluetooth on your phone, and open the Smart Life app.",
     "With the diffuser plugged in, quickly press the power button two times so it shows up in the app.",
     "Tap Add Device and follow the prompts.",
     "Enter your Wi-Fi password when asked."
    ]
   },
   {
    "title": "Clean it every 1–2 months",
    "body": [
     "Unplug it. Lift the top part out.",
     "Pour the oil back into its own bottle. Add a little Waterless Diffuser Cleaner (or 70–91% rubbing alcohol) to the empty one.",
     "Screw it back in and plug it in. Run it at L1 for 5–10 minutes (15 with alcohol).",
     "Unplug it, pour out the cleaner and refill. Wipe the outside with a damp cloth."
    ]
   }
  ]
 },
 "tower-ultra": {
  "steps": [
   {
    "title": "Check the box",
    "body": [
     "Your box has the Tower Ultra, an empty 120 ml bottle and a remote.",
     "It also has a USB-C cable, a power adapter, a metal hook, a spare nozzle and a rubber seal ring."
    ]
   },
   {
    "title": "Fill the bottle",
    "body": [
     "Lift the top part straight out. The bottle comes up with it.",
     "Unscrew the bottle and fill it with waterless fragrance oil. Never add water.",
     "Screw it back on until snug, with the straw down in the oil.",
     "Lower the top part back in until it sits flush. There's no click."
    ]
   },
   {
    "title": "Charge it and stand it up",
    "body": [
     "Charge it with the USB-C cable and power adapter from the box, in a wall outlet.",
     "Use only that cable and adapter.",
     "Stand it upright on a steady surface.",
     "Don't tilt it with oil inside."
    ]
   },
   {
    "title": "Turn it on and pick a level",
    "body": [
     "Hold the power button for 2–3 seconds, or use the remote.",
     "Set the level with the remote or the Smart Life app.",
     "L1 is the strongest: 30 seconds on, 60 off.",
     "Start on L6, the lightest (30 seconds on, 6 minutes off), and step up."
    ]
   },
   {
    "title": "Set the timer",
    "body": [
     "Out of the box it switches itself off after 4 hours.",
     "Pick a 1, 2, 4 or 8-hour timer on the remote."
    ]
   },
   {
    "title": "Connect the Smart Life app",
    "body": [
     "Turn on Wi-Fi and Bluetooth on your phone, and open the Smart Life app.",
     "Keep the diffuser on and close to your phone.",
     "Tap Add Device and follow the prompts.",
     "Enter your Wi-Fi password when asked."
    ]
   },
   {
    "title": "Clean it every 1–2 months",
    "body": [
     "Turn it off, and unplug it if it's charging. Lift the top part out.",
     "Pour the oil back into its own bottle. Add a little Waterless Diffuser Cleaner (or 70–91% rubbing alcohol) to the empty one.",
     "Screw it back in. Run it at L1 for 5–10 minutes (15 with alcohol).",
     "Turn it off, pour out the cleaner and refill. Wipe the outside with a damp cloth."
    ]
   }
  ]
 },
 "fabric-tower": {
  "steps": [
   {
    "title": "Check the box",
    "body": [
     "Your box has the diffuser, an empty 120 ml bottle and a remote.",
     "It also has a USB-C cable, an adapter, a metal hook, a spare nozzle and a rubber seal ring."
    ]
   },
   {
    "title": "Fill the bottle",
    "body": [
     "Lift the top part straight out. The bottle comes up with it.",
     "Unscrew the bottle and fill it with waterless fragrance oil. Never add water.",
     "Screw it back on until snug, with the straw down in the oil.",
     "Lower the top part back in until it sits flush. There's no click."
    ]
   },
   {
    "title": "Plug it in and turn it on",
    "body": [
     "Stand it upright on a flat, steady surface. Don't tilt it with oil inside.",
     "Plug in the USB-C cable and adapter from the box. Don't use any other charger.",
     "Hold the power button on the front for 2 seconds, or press ON/OFF on the remote."
    ]
   },
   {
    "title": "Choose the strength",
    "body": [
     "Out of the box it's on L2: 30 seconds on, 2 minutes off.",
     "Press L1 to L6 on the remote. No remote? Press the power button once to step up a level.",
     "L1 is the strongest: 30 seconds on, 60 seconds off.",
     "L6 is the lightest: 30 seconds on, 6 minutes off."
    ]
   },
   {
    "title": "Set the timer and light",
    "body": [
     "Out of the box it switches itself off after 4 hours.",
     "Double-press the power button to change it. One light is 1 hour, two 2 hours, three 4 hours, four 8 hours.",
     "Or press 1H, 4H or 8H on the remote.",
     "Press LIGHT on the remote for low, medium, high or off."
    ]
   },
   {
    "title": "Clean it every 1–2 months",
    "body": [
     "Unplug it. Lift the top part out.",
     "Pour the oil back into its own bottle. Add a little Waterless Diffuser Cleaner (or 70–91% rubbing alcohol) to the empty one.",
     "Screw it back in and plug it in. Run it at L1 for 5–10 minutes (15 with alcohol).",
     "Unplug it, pour out the cleaner and refill. Wipe the outside with a damp cloth."
    ]
   }
  ]
 },
 "soft-illumination": {
  "steps": [
   {
    "title": "Check the box",
    "body": [
     "Your box has the diffuser, an empty 120 ml bottle and a remote.",
     "It also has a USB-C cable, an adapter, a metal hook, a spare nozzle and a rubber seal ring."
    ]
   },
   {
    "title": "Fill the bottle",
    "body": [
     "Lift the top part straight out. The bottle comes up with it.",
     "Unscrew the bottle and fill it with waterless fragrance oil. Never add water.",
     "Screw it back on until snug, with the straw down in the oil.",
     "Lower the top part back in until it sits flush. There's no click."
    ]
   },
   {
    "title": "Plug it in and turn it on",
    "body": [
     "Stand it upright on a flat, steady surface. Don't tilt it with oil inside.",
     "Plug in the USB-C cable and adapter from the box. Don't use any other charger.",
     "Hold the power button on the front for 2 seconds, or press ON/OFF on the remote."
    ]
   },
   {
    "title": "Choose the strength",
    "body": [
     "Out of the box it starts on L6, the lightest: 30 seconds on, 6 minutes off.",
     "Press L1 to L6 on the remote. No remote? Press the power button once to step up a level.",
     "L1 is the strongest: 30 seconds on, 60 seconds off.",
     "L6 is the lightest: 30 seconds on, 6 minutes off."
    ]
   },
   {
    "title": "Set the timer and light",
    "body": [
     "Out of the box it switches itself off after 4 hours.",
     "Double-press the power button to change it. One light is 1 hour, two 2 hours, three 4 hours, four 8 hours.",
     "Or press 1H, 4H or 8H on the remote.",
     "Press LIGHT on the remote for low, medium, high or off."
    ]
   },
   {
    "title": "Clean it every 1–2 months",
    "body": [
     "Unplug it. Lift the top part out.",
     "Pour the oil back into its own bottle. Add a little Waterless Diffuser Cleaner (or 70–91% rubbing alcohol) to the empty one.",
     "Screw it back in and plug it in. Run it at L1 for 5–10 minutes (15 with alcohol).",
     "Unplug it, pour out the cleaner and refill. Wipe the outside with a damp cloth."
    ]
   }
  ]
 },
 "powerflow": {
  "steps": [
   {
    "title": "Check the box",
    "body": [
     "Your box has the diffuser, a nozzle with an empty 200 ml bottle, a USB-C cable, an adapter and a remote."
    ]
   },
   {
    "title": "Fill the bottle",
    "body": [
     "Hold the spray head straight up and pull the nozzle out. Don't twist it.",
     "Take the bottle off the nozzle and fill it with waterless fragrance oil.",
     "Put the bottle back on, then put the nozzle back in, lined up with the diffuser.",
     "Keep it upright from now on. Tipping it with oil inside can leak."
    ]
   },
   {
    "title": "Plug it in and turn it on",
    "body": [
     "Plug in the USB-C cable and wall adapter from the box. Don't use any other charger.",
     "Press the power button once to turn it on.",
     "Hold it for 2 seconds to turn it off."
    ]
   },
   {
    "title": "Choose the spray time",
    "body": [
     "Press the power button again, or use the remote, to switch between 10S, 30S, 60S and 90S.",
     "For the strongest scent, use 30S or 60S. Both spray about 10 minutes every hour.",
     "10S and 90S are gentler, at about 5 and 6 minutes an hour.",
     "The lit mode light stays steady while it sprays and flashes while it rests."
    ]
   },
   {
    "title": "Set the timer",
    "body": [
     "Press the timer button, or use the remote, to pick 1, 3, 6 or 8 hours.",
     "It switches itself off when the timer ends."
    ]
   },
   {
    "title": "Use it safely",
    "body": [
     "Use it in a room between 10°C and 50°C.",
     "Keep it away from children and pets.",
     "For long breaks, take out the oil bottle and store it."
    ]
   },
   {
    "title": "Clean it when you change scents",
    "body": [
     "Unplug it, pull the nozzle out and pour the oil back into its own bottle.",
     "Add a little Waterless Diffuser Cleaner to the diffuser's bottle and put the nozzle back in.",
     "Plug it in, set 60S and let it spray 3 times, about 18 minutes.",
     "Empty the cleaner, let it air out a few minutes, then fill with your new scent."
    ]
   }
  ]
 },
 "candlelight": {
  "steps": [
   {
    "title": "Charge it",
    "body": [
     "Use the USB-C cable from the box in a power bank or a 5V USB wall adapter, not a phone fast-charger.",
     "Leave it on charge for a few hours."
    ]
   },
   {
    "title": "Fill it with oil",
    "body": [
     "Turn it off and unplug the cable. Lift the lid straight up.",
     "Pour waterless fragrance oil straight into the diffuser. It holds up to 80 ml.",
     "There's no separate bottle."
    ]
   },
   {
    "title": "Connect the mist pieces",
    "body": [
     "Push the small connector onto the atomizer under the lid until it doesn't wiggle.",
     "Push the pipe onto the other side of the connector.",
     "Lower the lid back on slowly, so the bottom of the pipe sits in the oil."
    ]
   },
   {
    "title": "Turn it on and pick a strength",
    "body": [
     "Press and hold the left (power) button for 1 second. A white light comes on.",
     "It starts on the lightest: 15 seconds on, 165 off.",
     "Click the left button once for 60 seconds on, 120 off.",
     "Click it again for the strongest: 120 seconds on, 60 off."
    ]
   },
   {
    "title": "Set the timer",
    "body": [
     "It switches itself off after 8 hours by default.",
     "Click the right (timer) button for 1, 2 or 3 hours. A green light shows the timer."
    ]
   },
   {
    "title": "Pick a light",
    "body": [
     "It starts with a white light.",
     "Click the light button to cycle through 9 light modes, ending with off.",
     "Hold the light button for 3 seconds to turn the breathing effect on or off."
    ]
   },
   {
    "title": "Keep it upright",
    "body": [
     "Keep it on a flat, steady surface.",
     "Never tip or tilt it with oil inside, not even to empty it.",
     "Turn it off and unplug it before you open the lid."
    ]
   }
  ]
 },
 "mini": {
  "steps": [
   {
    "title": "Check the box",
    "body": [
     "Your box has the diffuser, a nozzle with an empty bottle and a USB-C cable.",
     "The nozzle screws onto 5, 10 or 20 ml bottles."
    ]
   },
   {
    "title": "Charge it",
    "body": [
     "Use the USB-C cable from the box in a computer USB port or a 5V USB wall adapter, not a phone fast-charger.",
     "The power button flickers while charging.",
     "It stays lit when it's full, after about 2–3 hours."
    ]
   },
   {
    "title": "Fill the bottle",
    "body": [
     "Turn it off and unplug the cable. Push the bottle up from the bottom to lift out the nozzle.",
     "Unscrew the bottle from the nozzle and fill it with waterless fragrance oil.",
     "Screw it back onto the nozzle.",
     "Put the nozzle back so its arrow lines up with the arrow on the diffuser."
    ]
   },
   {
    "title": "Turn it on and pick a strength",
    "body": [
     "Press the On/Off (power-symbol) button. The spray-time light turns green.",
     "It starts on 15-second sprays, the lightest: 15 seconds on, 165 off.",
     "Short-touch On/Off to step to 60, then 120 seconds.",
     "120 seconds on, 60 off is the strongest."
    ]
   },
   {
    "title": "Set the timer",
    "body": [
     "It switches itself off after 8 hours by default.",
     "Short-touch the clock button for 1, 2 or 3 hours."
    ]
   },
   {
    "title": "Keep it upright",
    "body": [
     "Don't turn it over or tilt it with oil inside. It can damage the pump.",
     "In a car, wedge it upright so it can't tip over.",
     "Use it between 10°C and 50°C. Don't leave it in a hot parked car.",
     "For long breaks, take out the nozzle and store it separately."
    ]
   },
   {
    "title": "Clean it when you change scents",
    "body": [
     "Pour the oil back into its original bottle. Put a little Waterless Diffuser Cleaner in the empty one.",
     "Screw it back on and line up the arrows.",
     "Turn it on, set 120-second sprays and run it 10 minutes.",
     "Pour out the cleaner and refill with waterless fragrance oil."
    ]
   }
  ]
 },
 "luxury-plugin": {
  "steps": [
   {
    "title": "Fill the bottle",
    "body": [
     "Unplug it first.",
     "Push the bottle out from the bottom of the diffuser.",
     "Fill it with waterless fragrance oil, up to 20 ml.",
     "Rotate the bottle back in firmly."
    ]
   },
   {
    "title": "Plug it in and turn it on",
    "body": [
     "With dry hands, plug it straight into a wall outlet.",
     "Hold the On/Off button for 2 seconds.",
     "A quick tap only changes the strength."
    ]
   },
   {
    "title": "Choose the strength",
    "body": [
     "It starts on 15 seconds, the lightest: 15 seconds on, 165 off.",
     "Short-tap the On/Off button to step to 60, then 120 seconds.",
     "120 seconds on, 60 off is the strongest."
    ]
   },
   {
    "title": "Set the timer",
    "body": [
     "It switches itself off after 8 hours by default.",
     "Short-tap the Timer button for 1, 2, 3 or 8 hours."
    ]
   },
   {
    "title": "Turn on the light",
    "body": [
     "Hold the Timer button for 1 second. The warm white light comes on.",
     "While it's on, press the Timer button to change the color.",
     "Hold it for 1 second again to turn the light off."
    ]
   },
   {
    "title": "Use Light Sensor Mode",
    "body": [
     "Hold the Timer and On/Off buttons together for 1 second.",
     "It then runs when there's light and pauses in the dark.",
     "The timer doesn't work in this mode.",
     "Hold both buttons again to turn it off."
    ]
   },
   {
    "title": "Clean it every 1–2 months",
    "body": [
     "Unplug it, empty the oil and pour Waterless Diffuser Cleaner into the bottle.",
     "Put it back, dry your hands and plug it in. Run it on 120 seconds for 5–10 minutes.",
     "No cleaner? 70–91% rubbing alcohol works too. Run it for 15 minutes.",
     "Unplug it, empty it and refill. Keep it upright with oil inside."
    ]
   }
  ]
 },
 "contour": {
  "steps": [
   {
    "title": "Check the box",
    "body": [
     "Your box has the diffuser, a 60 ml bottle, a cap and the manual."
    ]
   },
   {
    "title": "Fill the bottle",
    "body": [
     "Unplug it, then lift the head and bottle out together.",
     "Twist the head off and fill the bottle with waterless fragrance oil.",
     "Twist the head back on tightly.",
     "Line it up and press it back down into the diffuser."
    ]
   },
   {
    "title": "Plug it in and pick a mode",
    "body": [
     "Plug it into a wall outlet. It beeps once.",
     "Short-press the Mode button to choose 3H, 6H, Smart or Off.",
     "Blue light means running. Yellow means resting on its daily timer. Red means off."
    ]
   },
   {
    "title": "Choose the strength",
    "body": [
     "Short-press the Grade button to step 1, 2, 3.",
     "Grade 3 is the strongest: 15 seconds on, 60 off.",
     "Grade 1 is the gentlest: 15 seconds on, 120 off."
    ]
   },
   {
    "title": "Understand the timer",
    "body": [
     "3H runs for 3 hours, then rests for 21 hours.",
     "6H runs for 6 hours, then rests for 18 hours.",
     "It repeats every day."
    ]
   },
   {
    "title": "Connect the Scent Marketing app",
    "body": [
     "Turn on Bluetooth and location on your phone, then open the Scent Marketing app.",
     "Choose the Bluetooth version, select your diffuser and sign in with the password 8888.",
     "Set the hours, days and grade, then press Save.",
     "Short-press Mode to Smart so it follows your app schedule."
    ]
   },
   {
    "title": "Keep it upright and clean",
    "body": [
     "Keep it upright. Laying it flat can make oil overflow. Empty it before you move it.",
     "Every 1–2 months, or when you switch oils, unplug it and lift out the head and bottle.",
     "Soak them in 70–91% isopropyl rubbing alcohol for 5–10 minutes.",
     "Let them dry fully before you refill."
    ]
   }
  ]
 },
 "arc-touch": {
  "steps": [
   {
    "title": "Fill the bottle",
    "body": [
     "Take off the upper cover.",
     "Fill the inner bottle with waterless fragrance oil, up to 30 ml. Never add water.",
     "Secure the bottle and put the cover back on."
    ]
   },
   {
    "title": "Plug it in and turn it on",
    "body": [
     "Turn the plug so the diffuser hangs upright, whichever way your outlet faces.",
     "With dry hands, plug it into a wall outlet.",
     "Press and hold the timer button to turn it on."
    ]
   },
   {
    "title": "Choose the strength",
    "body": [
     "Short-press the output control to pick L1 to L4.",
     "L1 is the gentlest: 20 seconds on, 300 off.",
     "L4 is the strongest: 140 seconds on, 300 off."
    ]
   },
   {
    "title": "Set the timer",
    "body": [
     "Short-press the timer button for 1, 2, 4 or 8 hours."
    ]
   },
   {
    "title": "Care for it",
    "body": [
     "Unplug it before you refill or clean it.",
     "Keep it upright, away from water and steam. Don't tilt it with oil inside.",
     "Every month, and after a long break, empty it and add Waterless Diffuser Cleaner to the bottle.",
     "Run it on L4 for 5–10 minutes, then unplug it, empty it and refill."
    ]
   }
  ]
 },
 "night-light": {
  "steps": [
   {
    "title": "Fill the bottle",
    "body": [
     "Take out the inner bottle and fill it with waterless fragrance oil.",
     "Never add water.",
     "Put the inner bottle back in firmly."
    ]
   },
   {
    "title": "Plug it in",
    "body": [
     "With dry hands, plug it straight into a wall outlet.",
     "Press the light button. If the night light comes on, it has power."
    ]
   },
   {
    "title": "Choose the strength",
    "body": [
     "Use the buttons on the diffuser to pick one of 3 modes.",
     "Start with the lowest and step up."
    ]
   },
   {
    "title": "Set the timer",
    "body": [
     "Use the buttons on the diffuser to pick a 1, 2, 3 or 8-hour run timer."
    ]
   },
   {
    "title": "Turn on the light",
    "body": [
     "Press the light button to turn the night light on or off.",
     "It doesn't turn on by itself in the dark."
    ]
   },
   {
    "title": "Care for it",
    "body": [
     "Unplug it before you refill or clean it.",
     "Keep it upright with oil inside.",
     "When you change scents, clean the inner bottle with Waterless Diffuser Cleaner.",
     "Then run the cleaner through the diffuser."
    ]
   }
  ]
 },
 "smart-car": {
  "steps": [
   {
    "title": "Check the box",
    "body": [
     "Your box has the diffuser, a vent clip, three fragrance cartridges and a USB-C cable."
    ]
   },
   {
    "title": "Charge it",
    "body": [
     "Charge it with the USB-C cable from the box, not a phone fast-charger.",
     "A full charge takes about an hour.",
     "Expect up to 45 days per charge with normal use in the car."
    ]
   },
   {
    "title": "Put in a cartridge and clip it on",
    "body": [
     "Push one of the fragrance cartridges from the box in firmly.",
     "Clip the diffuser onto a car vent slat.",
     "Pick a spot where it doesn't block your view or the controls."
    ]
   },
   {
    "title": "Turn it on and pick a mode",
    "body": [
     "Press the button on the diffuser.",
     "Press it again to pick one of 3 modes: a quick puff every 5 minutes, 90 seconds or 10 seconds.",
     "Start with the lightest, one puff every 5 minutes."
    ]
   },
   {
    "title": "Let it run",
    "body": [
     "It starts and stops by itself when it senses the car is in use.",
     "So it pauses when the car is parked."
    ]
   },
   {
    "title": "Change the cartridge",
    "body": [
     "A nearly empty cartridge gives less scent.",
     "Turn it off, take out the cartridge and push a fresh one in firmly."
    ]
   }
  ]
 },
 "hvac-plus": {
  "steps": [
   {
    "title": "Check the box",
    "body": [
     "Your box has the diffuser, an empty 280 ml bottle, a 12 V power adapter and a 1.6 m HVAC tube."
    ]
   },
   {
    "title": "Fill the bottle",
    "body": [
     "Keep it unplugged. Unlock and open the front door, then unscrew the oil bottle.",
     "Fill it with waterless fragrance oil.",
     "Screw the bottle back in firmly.",
     "Close and lock the door."
    ]
   },
   {
    "title": "Choose where it goes",
    "body": [
     "Set it on a table or mount it on a wall in your home.",
     "Connecting it to your home's HVAC? Follow the hookup instructions in the box.",
     "Keep it upright, and keep the air outlet on top clear."
    ]
   },
   {
    "title": "Plug it in and turn it on",
    "body": [
     "Push the round plug of the 12 V adapter from the box all the way into the socket on the side.",
     "Hold the power button (the middle one) for 1 second.",
     "The fan comes on with the power.",
     "A quick press only switches the fan off or on."
    ]
   },
   {
    "title": "Choose the strength and timer",
    "body": [
     "It starts on Level 1, the lightest: 15 seconds on, 165 off.",
     "Press MIST for Level 2, then Level 3, the strongest: 120 seconds on, 60 off.",
     "It switches itself off after 8 hours by default.",
     "Press TIME to pick 1, 2, 3 or 8 hours."
    ]
   },
   {
    "title": "Connect the Smart Life app",
    "body": [
     "Turn on Wi-Fi and Bluetooth on your phone, and open the Smart Life app.",
     "With the diffuser on, hold MIST for 5 seconds. The Wi-Fi icon starts flashing.",
     "In the app, tap Add on SCENT DIFFUSER, enter your Wi-Fi password and tap Next.",
     "The icon stops flashing once it's connected."
    ]
   },
   {
    "title": "Care for it",
    "body": [
     "Hold the power button for 1 second to turn it off, then unplug it before you open the door.",
     "Never tilt it with oil inside.",
     "To clean it or change scents, use only Waterless Diffuser Cleaner.",
     "Never use rubbing alcohol or other solvents in it."
    ]
   }
  ]
 },
 "humid": {
  "steps": [
   {
    "title": "Fill with water",
    "body": [
     "Unplug it first.",
     "Add clean water up to the max line. Never fill past it.",
     "Most models switch off on their own when the water runs low. Just refill."
    ]
   },
   {
    "title": "Add the right oil",
    "body": [
     "Add a few drops of oil made for humidifying diffusers.",
     "Most of our models suggest 3–5 drops. Your product page has the count.",
     "Don't use waterless fragrance oil in it."
    ]
   },
   {
    "title": "Close it up and place it",
    "body": [
     "Set the cover back on so it sits evenly.",
     "Stand it on a hard, flat surface.",
     "Keep the air inlet clear."
    ]
   },
   {
    "title": "Plug it in and turn it on",
    "body": [
     "Use the cable and adapter that came in the box.",
     "Don't use a phone fast-charger.",
     "Press the power button to start the mist."
    ]
   },
   {
    "title": "Choose your settings",
    "body": [
     "If yours has a mist level, timer or light buttons, set them now.",
     "If it came with a remote, you can use that too.",
     "Light and mist are often separate buttons."
    ]
   },
   {
    "title": "Clean the disc",
    "body": [
     "When the mist gets weaker, unplug it and pour the water out. Never put the base in water.",
     "Gently wipe the small round disc with a cotton swab dipped in 70–91% isopropyl alcohol.",
     "Don't scrub it or use household cleaners.",
     "Let it air out, then refill."
    ]
   },
   {
    "title": "Deep clean now and then",
    "body": [
     "Unplug it and pour the water out.",
     "Add water and the recommended amount of Humidifying Diffuser Cleaner.",
     "Let it sit 10–15 minutes, then empty it, rinse it well and wipe it dry.",
     "Do this weekly with hard tap water, or every 2–3 weeks with distilled water."
    ]
   }
  ]
 }
};
